import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useReportMenuOpened = ({ messageId }: { messageId: number }) =>
	useSendEvent(events.report.menuOpened, {
		MsgId: messageId,
	});

export const useReportButtonClicked = ({ messageId }: { messageId: number }) =>
	useSendEvent(events.report.buttonClicked, { MsgId: messageId });

export const useReportSubmitted = () =>
	useSendEvent(events.report.reportSubmitted);

export const useUGCBotReport = ({
	botId,
	status,
	botName,
}: {
	status: 'public' | 'private';
	botName: string;
	botId: string;
}) =>
	useSendEvent(events.report.ugcBotReport, {
		bot_UserId: botId,
		bot_status: status,
		bot_name: botName,
	});
